module.exports = __webpack_public_path__ + "static/media/chartPathBig.ffe6a78d.png";